'use strict';

const vueFormAppEl = '.vue-form-app';

const createVueForms = () => {
    document.querySelectorAll(vueFormAppEl).forEach(el => {
        renderVueForm(el);
    });
};

const renderVueForm = (el) => {
    const Vue = require('vue');
    const VueForm = require('./vue-form/vue-form.vue');
    const VueInput = require('./vue-input/vue-input.vue');

    return new Vue({
        el: el,
        components: {
            VueForm,
            VueInput
        }
    });
};

const shouldInit = () => {
    return document.querySelectorAll(vueFormAppEl).length > 0;
};

const vueFormApp = {
    init: () => {
        if (shouldInit()) {
            createVueForms();
        }
    }
};

module.exports = vueFormApp;
